// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, type Composable, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { ActiviteActiviteGetByIdData, ActiviteActiviteGetByIdError, ActiviteActiviteGetByIdResponse, ActiviteCreateData, ActiviteCreateError, ActiviteCreateResponse, ActiviteDeleteByIdData, ActiviteDeleteByIdError, ActiviteDeleteByIdResponse, ActiviteGetAllData, ActiviteGetAllError, ActiviteGetAllResponse, ActiviteGetAllWithPagingData, ActiviteGetAllWithPagingError, ActiviteGetAllWithPagingResponse, ActiviteUpdateData, ActiviteUpdateError, ActiviteUpdateResponse, AdresseAdresseGetByIdData, AdresseAdresseGetByIdError, AdresseAdresseGetByIdResponse, AdresseCreateData, AdresseCreateError, AdresseCreateResponse, AdresseDeleteByIdData, AdresseDeleteByIdError, AdresseDeleteByIdResponse, AdresseGetAllData, AdresseGetAllError, AdresseGetAllResponse, AdresseGetAllWithPagingData, AdresseGetAllWithPagingError, AdresseGetAllWithPagingResponse, AdresseGetByStructureData, AdresseGetByStructureError, AdresseGetByStructureResponse, AdresseGetByStructureTypeData, AdresseGetByStructureTypeError, AdresseGetByStructureTypeResponse, AdresseUpdateData, AdresseUpdateError, AdresseUpdateResponse, BrevetExterneBrevetExterneGetByIdData, BrevetExterneBrevetExterneGetByIdError, BrevetExterneBrevetExterneGetByIdResponse, BrevetExterneCreateData, BrevetExterneCreateError, BrevetExterneCreateResponse, BrevetExterneDeleteByIdData, BrevetExterneDeleteByIdError, BrevetExterneDeleteByIdResponse, BrevetExterneGetAllData, BrevetExterneGetAllError, BrevetExterneGetAllResponse, BrevetExterneGetAllWithPagingData, BrevetExterneGetAllWithPagingError, BrevetExterneGetAllWithPagingResponse, BrevetExterneGetByLicencieData, BrevetExterneGetByLicencieError, BrevetExterneGetByLicencieResponse, BrevetExterneSaveForLicencieData, BrevetExterneSaveForLicencieError, BrevetExterneUpdateData, BrevetExterneUpdateError, BrevetExterneUpdateResponse, CategorieSocioProfessionnelleCategorieSocioProfessionnelleGetByIdData, CategorieSocioProfessionnelleCategorieSocioProfessionnelleGetByIdError, CategorieSocioProfessionnelleCategorieSocioProfessionnelleGetByIdResponse, CategorieSocioProfessionnelleCreateData, CategorieSocioProfessionnelleCreateError, CategorieSocioProfessionnelleCreateResponse, CategorieSocioProfessionnelleDeleteByIdData, CategorieSocioProfessionnelleDeleteByIdError, CategorieSocioProfessionnelleDeleteByIdResponse, CategorieSocioProfessionnelleGetAllData, CategorieSocioProfessionnelleGetAllError, CategorieSocioProfessionnelleGetAllResponse, CategorieSocioProfessionnelleGetAllWithPagingData, CategorieSocioProfessionnelleGetAllWithPagingError, CategorieSocioProfessionnelleGetAllWithPagingResponse, CategorieSocioProfessionnelleUpdateData, CategorieSocioProfessionnelleUpdateError, CategorieSocioProfessionnelleUpdateResponse, ClubScaCheckMailAvailabilityData, ClubScaCheckMailAvailabilityError, ClubScaCheckMailAvailabilityResponse, ClubScaClubScaGetByIdData, ClubScaClubScaGetByIdError, ClubScaClubScaGetByIdResponse, ClubScaCodeExistsData, ClubScaCodeExistsResponse, ClubScaCreateData, ClubScaCreateError, ClubScaCreateResponse, ClubScaDeleteByIdData, ClubScaDeleteByIdError, ClubScaDeleteByIdResponse, ClubScaGetAllData, ClubScaGetAllError, ClubScaGetAllResponse, ClubScaGetByComiteDepartementalIdData, ClubScaGetByComiteDepartementalIdResponse, ClubScaGetByComiteRegionalIdData, ClubScaGetByComiteRegionalIdResponse, ClubScaGetPanierSubData, ClubScaGetPanierSubError, ClubScaGetPanierSubResponse, ClubScaGetQuickViewData, ClubScaGetQuickViewResponse, ClubScaGetTypeAdressesData, ClubScaGetTypeAdressesResponse, ClubScaPackLicencesData, ClubScaPackLicencesError, ClubScaPackLicencesResponse, ClubScaSearch2Data, ClubScaSearch2Response, ClubScaSearchCommuneData, ClubScaSearchCommuneResponse, ClubScaSearchData, ClubScaSearchDepartementData, ClubScaSearchDepartementResponse, ClubScaSearchListIdsData, ClubScaSearchListIdsResponse, ClubScaSearchPolygonData, ClubScaSearchPolygonResponse, ClubScaSearchRayonData, ClubScaSearchRayonResponse, ClubScaSearchRegionData, ClubScaSearchRegionResponse, ClubScaSearchResponse, ClubScaSearchZoneGeographiqueData, ClubScaSearchZoneGeographiqueResponse, ClubScaSetPanierSubEmailData, ClubScaSetPanierSubEmailError, ClubScaUpdateData, ClubScaUpdateError, ClubScaUpdateResponse, ClubScaUploadLogoData, ClubScaUploadLogoError, ClubScaUploadLogoResponse, CommuneCommuneGetByIdData, CommuneCommuneGetByIdError, CommuneCommuneGetByIdResponse, CommuneGetAllData, CommuneGetAllError, CommuneGetAllResponse, CommuneGetAllWithPagingData, CommuneGetAllWithPagingError, CommuneGetAllWithPagingResponse, CommuneGetByDepartementData, CommuneGetByDepartementError, CommuneGetByDepartementResponse, CommuneGetByRegionData, CommuneGetByRegionError, CommuneGetByRegionResponse, CommuneGetCommuneByNameData, CommuneGetCommuneByNameError, CommuneGetCommuneByNameResponse, CommuneGetCommunesAdjacentesData, CommuneGetCommunesAdjacentesError, CommuneGetCommunesAdjacentesResponse, CommuneGetCommunesByPostalCodeData, CommuneGetCommunesByPostalCodeError, CommuneGetCommunesByPostalCodeResponse, LicenceCardRenewalData, LicenceCardRenewalError, LicenceCardRenewalResponse, LicenceCreateData, LicenceCreateError, LicenceCreatePastLicenceData, LicenceCreatePastLicenceError, LicenceCreateResponse, LicenceDeleteByIdData, LicenceDeleteByIdError, LicenceDeleteByIdResponse, LicenceDeleteWithCreditData, LicenceDeleteWithCreditError, LicenceDeleteWithCreditResponse, LicenceGetAllByLicencieIdData, LicenceGetAllByLicencieIdError, LicenceGetAllByLicencieIdResponse, LicenceImportGeneralGnpuData, LicenceImportGeneralGnpuError, LicenceImportGeneralGnpuResponse, LicenceLicenceExisteData, LicenceLicenceExisteError, LicenceLicenceExisteResponse, LicenceLicenceGetByIdData, LicenceLicenceGetByIdError, LicenceLicenceGetByIdResponse, LicenceUpdateData, LicenceUpdateError, LicenceUpdateResponse, LicencieActivateLicenceeData, LicencieActivateLicenceeResponse, LicencieAnonymousCreateData, LicencieAnonymousCreateError, LicencieAnonymousCreateResponse, LicencieChangeLicenceNumberData, LicencieChangeLicenceNumberError, LicencieCheckAndCreateData, LicencieCheckAndCreateError, LicencieCheckAndCreateResponse, LicencieCheckBirthPlaceData, LicencieCheckBirthPlaceError, LicencieCheckBirthPlaceResponse, LicencieControlEmailUsageData, LicencieControlEmailUsageError, LicencieControlEmailUsageResponse, LicencieCountEmailUsageData, LicencieCountEmailUsageError, LicencieCountEmailUsageResponse, LicencieCreateData, LicencieCreateError, LicencieCreateResponse, LicencieFusionLicencieData, LicencieFusionLicencieError, LicencieFusionLicencieResponse, LicencieGetAllUnusedNumsChronoData, LicencieGetAllUnusedNumsChronoError, LicencieGetAllUnusedNumsChronoResponse, LicencieGetBrevetByLicencieData, LicencieGetBrevetByLicencieResponse, LicencieGetBrevetByMoniteurData, LicencieGetBrevetByMoniteurResponse, LicencieGetBrevetsExtractionByLicencieIdData, LicencieGetBrevetsExtractionByLicencieIdError, LicencieGetBrevetsExtractionByLicencieIdResponse, LicencieGetByClubDateModificationData, LicencieGetByClubDateModificationResponse, LicencieGetByComiteDateModificationData, LicencieGetByComiteDateModificationResponse, LicencieGetByDateModificationData, LicencieGetByDateModificationResponse, LicencieGetCaciData, LicencieGetCaciError, LicencieGetCaciResponse, LicencieGetDateMinBrevetData, LicencieGetDateMinBrevetError, LicencieGetDateMinBrevetResponse, LicencieGetLicencieByNumeroLicenceData, LicencieGetLicencieByNumeroLicenceResponse, LicencieGetNextUnusedNumChronoData, LicencieGetNextUnusedNumChronoError, LicencieGetNextUnusedNumChronoResponse, LicencieGetQrCodeData, LicencieGetQrCodeError, LicencieGetQrCodeResponse, LicencieGetUrlInfoLicencieData, LicencieGetUrlInfoLicencieError, LicencieGetUrlInfoLicencieResponse, LicencieLicencieCategorieChangeData, LicencieLicencieCategorieChangeError, LicencieLicencieCategorieChangeResponse, LicencieLicencieGetByIdData, LicencieLicencieGetByIdError, LicencieLicencieGetByIdResponse, LicencieListByEmailData, LicencieListByEmailError, LicencieListByEmailResponse, LicencieSearchByClubSca2Data, LicencieSearchByClubSca2Response, LicencieSearchByClubScaData, LicencieSearchByClubScaResponse, LicencieSearchData, LicencieSearchLicenciesData, LicencieSearchLicenciesResponse, LicencieSearchMoniteursData, LicencieSearchMoniteursResponse, LicencieSearchResponse, LicencieSuppressionLicencieData, LicencieSuppressionLicencieError, LicencieSuppressionLicencieResponse, LicencieUpdateData, LicencieUpdateError, LicencieUpdateResponse, LicencieUploadCertificatMedicalData, LicencieUploadCertificatMedicalError, LicencieUploadCertificatMedicalResponse, LicencieUploadPhotoOfficielleData, LicencieUploadPhotoOfficielleError, LicencieUploadPhotoOfficielleResponse, LicencieUploadPhotoProfilData, LicencieUploadPhotoProfilError, LicencieUploadPhotoProfilResponse, LicencieUploadPhotosData, LicencieUploadPhotosError, PaysAnonymousGetAllData, PaysAnonymousGetAllError, PaysAnonymousGetAllResponse, PaysGetAllData, PaysGetAllError, PaysGetAllResponse, SaisonCreateData, SaisonCreateError, SaisonCreateResponse, SaisonDeleteByIdData, SaisonDeleteByIdError, SaisonDeleteByIdResponse, SaisonGetAllData, SaisonGetAllError, SaisonGetAllResponse, SaisonGetAllWithPagingData, SaisonGetAllWithPagingError, SaisonGetAllWithPagingResponse, SaisonGetUntilNowData, SaisonGetUntilNowError, SaisonGetUntilNowResponse, SaisonSaisonGetByIdData, SaisonSaisonGetByIdError, SaisonSaisonGetByIdResponse, SaisonUpdateData, SaisonUpdateError, SaisonUpdateResponse, StructureGetAllData, StructureGetAllError, StructureGetAllResponse, StructureGetStructuresByComiteRegionalIdData, StructureGetStructuresByComiteRegionalIdError, StructureGetStructuresByComiteRegionalIdResponse, StructureListData, StructureListError, StructureListResponse, StructureSearchData, StructureSearchListIdsData, StructureSearchListIdsResponse, StructureSearchResponse, StructureStructureGetByIdData, StructureStructureGetByIdError, StructureStructureGetByIdResponse, StructureUploadLogoData, StructureUploadLogoError, StructureUploadLogoResponse, StructureVerrouillageData, StructureVerrouillageError, StructureVerrouillageResponse, TypeActiviteCreateData, TypeActiviteCreateError, TypeActiviteCreateResponse, TypeActiviteDeleteByIdData, TypeActiviteDeleteByIdError, TypeActiviteDeleteByIdResponse, TypeActiviteGetAllData, TypeActiviteGetAllError, TypeActiviteGetAllResponse, TypeActiviteGetAllWithPagingData, TypeActiviteGetAllWithPagingError, TypeActiviteGetAllWithPagingResponse, TypeActiviteTypeActiviteGetByIdData, TypeActiviteTypeActiviteGetByIdError, TypeActiviteTypeActiviteGetByIdResponse, TypeActiviteUpdateData, TypeActiviteUpdateError, TypeActiviteUpdateResponse, UtilisateurCarnetCurrentData, UtilisateurCarnetCurrentResponse, UtilisateurCheckIfExistByIdentifiantData, UtilisateurCheckIfExistByIdentifiantResponse, UtilisateurCheckIsActiveByIdentifiantData, UtilisateurCheckIsActiveByIdentifiantResponse, UtilisateurCheckIsActiveData, UtilisateurCheckIsActiveResponse, UtilisateurCurrentData, UtilisateurCurrentResponse, UtilisateurExterneCreateData, UtilisateurExterneCreateError, UtilisateurExterneCreateResponse, UtilisateurExterneDeleteByIdData, UtilisateurExterneDeleteByIdError, UtilisateurExterneDeleteByIdResponse, UtilisateurExterneGetAllData, UtilisateurExterneGetAllError, UtilisateurExterneGetAllResponse, UtilisateurExterneGetAllWithPagingData, UtilisateurExterneGetAllWithPagingError, UtilisateurExterneGetAllWithPagingResponse, UtilisateurExterneUpdateData, UtilisateurExterneUpdateError, UtilisateurExterneUpdateResponse, UtilisateurExterneUploadPhotoOfficielleData, UtilisateurExterneUploadPhotoOfficielleError, UtilisateurExterneUploadPhotoOfficielleResponse, UtilisateurExterneUploadPhotoProfilData, UtilisateurExterneUploadPhotoProfilError, UtilisateurExterneUploadPhotoProfilResponse, UtilisateurExterneUtilisateurExterneGetByIdData, UtilisateurExterneUtilisateurExterneGetByIdError, UtilisateurExterneUtilisateurExterneGetByIdResponse, UtilisateurGetMailForIdentifierData, UtilisateurGetMailForIdentifierResponse, UtilisateurGetUserByNumeroChronoData, UtilisateurGetUserByNumeroChronoResponse, UtilisateurMandarineCurrentData, UtilisateurMandarineCurrentResponse, UtilisateurProcessClientConnectionData, UtilisateurSearchCarnetData, UtilisateurSearchCarnetResponse, UtilisateurSearchData, UtilisateurSearchResponse, UtilisateurUtilisateurGetByIdData, UtilisateurUtilisateurGetByIdError, UtilisateurUtilisateurGetByIdResponse } from './types.gen';

export type Options<TComposable extends Composable = '$fetch', TData extends TDataShape = TDataShape, ResT = unknown, DefaultT = undefined> = Options2<TComposable, TData, ResT, DefaultT> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Listes Activites
 */
export const activiteGetAll = <TComposable extends Composable = '$fetch', DefaultT extends ActiviteGetAllResponse = ActiviteGetAllResponse>(options: Options<TComposable, ActiviteGetAllData, ActiviteGetAllResponse, DefaultT>) => (options.client ?? client).get<TComposable, ActiviteGetAllResponse | DefaultT, ActiviteGetAllError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Activite',
    ...options
});

/**
 * Création Activite
 */
export const activiteCreate = <TComposable extends Composable = '$fetch', DefaultT extends ActiviteCreateResponse = ActiviteCreateResponse>(options: Options<TComposable, ActiviteCreateData, ActiviteCreateResponse, DefaultT>) => (options.client ?? client).post<TComposable, ActiviteCreateResponse | DefaultT, ActiviteCreateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Activite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mise à jour Activite
 */
export const activiteUpdate = <TComposable extends Composable = '$fetch', DefaultT extends ActiviteUpdateResponse = ActiviteUpdateResponse>(options: Options<TComposable, ActiviteUpdateData, ActiviteUpdateResponse, DefaultT>) => (options.client ?? client).put<TComposable, ActiviteUpdateResponse | DefaultT, ActiviteUpdateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Activite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Listes Activites
 */
export const activiteGetAllWithPaging = <TComposable extends Composable = '$fetch', DefaultT extends ActiviteGetAllWithPagingResponse = ActiviteGetAllWithPagingResponse>(options: Options<TComposable, ActiviteGetAllWithPagingData, ActiviteGetAllWithPagingResponse, DefaultT>) => (options.client ?? client).post<TComposable, ActiviteGetAllWithPagingResponse | DefaultT, ActiviteGetAllWithPagingError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Activite/paging',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suppression Activite
 */
export const activiteDeleteById = <TComposable extends Composable = '$fetch', DefaultT extends ActiviteDeleteByIdResponse = ActiviteDeleteByIdResponse>(options: Options<TComposable, ActiviteDeleteByIdData, ActiviteDeleteByIdResponse, DefaultT>) => (options.client ?? client).delete<TComposable, ActiviteDeleteByIdResponse | DefaultT, ActiviteDeleteByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Activite/{Id}',
    ...options
});

/**
 * Récupérer Activite via son Id
 */
export const activiteActiviteGetById = <TComposable extends Composable = '$fetch', DefaultT extends ActiviteActiviteGetByIdResponse = ActiviteActiviteGetByIdResponse>(options: Options<TComposable, ActiviteActiviteGetByIdData, ActiviteActiviteGetByIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, ActiviteActiviteGetByIdResponse | DefaultT, ActiviteActiviteGetByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Activite/{Id}',
    ...options
});

/**
 * Récupérer Licencie via son Id
 */
export const licencieLicencieGetById = <TComposable extends Composable = '$fetch', DefaultT extends LicencieLicencieGetByIdResponse = LicencieLicencieGetByIdResponse>(options: Options<TComposable, LicencieLicencieGetByIdData, LicencieLicencieGetByIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieLicencieGetByIdResponse | DefaultT, LicencieLicencieGetByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/{Id}',
    ...options
});

/**
 * Création Licencie
 */
export const licencieCreate = <TComposable extends Composable = '$fetch', DefaultT extends LicencieCreateResponse = LicencieCreateResponse>(options: Options<TComposable, LicencieCreateData, LicencieCreateResponse, DefaultT>) => (options.client ?? client).post<TComposable, LicencieCreateResponse | DefaultT, LicencieCreateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mise à jour Licencie
 */
export const licencieUpdate = <TComposable extends Composable = '$fetch', DefaultT extends LicencieUpdateResponse = LicencieUpdateResponse>(options: Options<TComposable, LicencieUpdateData, LicencieUpdateResponse, DefaultT>) => (options.client ?? client).put<TComposable, LicencieUpdateResponse | DefaultT, LicencieUpdateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lister Licencie par Date Dernière Modification
 */
export const licencieGetByDateModification = <TComposable extends Composable = '$fetch', DefaultT extends LicencieGetByDateModificationResponse = LicencieGetByDateModificationResponse>(options: Options<TComposable, LicencieGetByDateModificationData, LicencieGetByDateModificationResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieGetByDateModificationResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/DateModification/{DateModificationDebut}/{DateModificationFin}',
    ...options
});

/**
 * Lister Licencie par comité et Date Dernière Modification
 */
export const licencieGetByComiteDateModification = <TComposable extends Composable = '$fetch', DefaultT extends LicencieGetByComiteDateModificationResponse = LicencieGetByComiteDateModificationResponse>(options: Options<TComposable, LicencieGetByComiteDateModificationData, LicencieGetByComiteDateModificationResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieGetByComiteDateModificationResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/Comite/{ComiteId}/DateModification/{DateModificationDebut}/{DateModificationFin}',
    ...options
});

/**
 * Lister Licencie par Club et Date Dernière Modification
 */
export const licencieGetByClubDateModification = <TComposable extends Composable = '$fetch', DefaultT extends LicencieGetByClubDateModificationResponse = LicencieGetByClubDateModificationResponse>(options: Options<TComposable, LicencieGetByClubDateModificationData, LicencieGetByClubDateModificationResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieGetByClubDateModificationResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/ClubSca/{ClubScaId}/DateModification/{DateModificationDebut}/{DateModificationFin}',
    ...options
});

/**
 * Chercher Licencie par nom, num licence
 */
export const licencieSearch = <TComposable extends Composable = '$fetch', DefaultT extends LicencieSearchResponse = LicencieSearchResponse>(options: Options<TComposable, LicencieSearchData, LicencieSearchResponse, DefaultT>) => (options.client ?? client).post<TComposable, LicencieSearchResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/Search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Chercher Licencie par nom, num licence dans un Club/Sca
 */
export const licencieSearchByClubSca = <TComposable extends Composable = '$fetch', DefaultT extends LicencieSearchByClubScaResponse = LicencieSearchByClubScaResponse>(options: Options<TComposable, LicencieSearchByClubScaData, LicencieSearchByClubScaResponse, DefaultT>) => (options.client ?? client).post<TComposable, LicencieSearchByClubScaResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/SearchClubSca',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enregistrement de la photo de profil
 */
export const licencieUploadPhotoOfficielle = <TComposable extends Composable = '$fetch', DefaultT extends LicencieUploadPhotoOfficielleResponse = LicencieUploadPhotoOfficielleResponse>(options: Options<TComposable, LicencieUploadPhotoOfficielleData, LicencieUploadPhotoOfficielleResponse, DefaultT>) => (options.client ?? client).post<TComposable, LicencieUploadPhotoOfficielleResponse | DefaultT, LicencieUploadPhotoOfficielleError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/{Id}/PhotoOfficielle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enregistrement de la photo de profil
 */
export const licencieUploadPhotoProfil = <TComposable extends Composable = '$fetch', DefaultT extends LicencieUploadPhotoProfilResponse = LicencieUploadPhotoProfilResponse>(options: Options<TComposable, LicencieUploadPhotoProfilData, LicencieUploadPhotoProfilResponse, DefaultT>) => (options.client ?? client).post<TComposable, LicencieUploadPhotoProfilResponse | DefaultT, LicencieUploadPhotoProfilError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/{Id}/PhotoProfil',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enregistrement des photos
 */
export const licencieUploadPhotos = <TComposable extends Composable = '$fetch', DefaultT = undefined>(options: Options<TComposable, LicencieUploadPhotosData, unknown, DefaultT>) => (options.client ?? client).post<TComposable, unknown | DefaultT, LicencieUploadPhotosError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/{Id}/Photos',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enregistrement du certificat médical
 */
export const licencieUploadCertificatMedical = <TComposable extends Composable = '$fetch', DefaultT extends LicencieUploadCertificatMedicalResponse = LicencieUploadCertificatMedicalResponse>(options: Options<TComposable, LicencieUploadCertificatMedicalData, LicencieUploadCertificatMedicalResponse, DefaultT>) => (options.client ?? client).post<TComposable, LicencieUploadCertificatMedicalResponse | DefaultT, LicencieUploadCertificatMedicalError, DefaultT>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/{Id}/CertificatMedical',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Brevets d'un licencié
 */
export const licencieGetBrevetByLicencie = <TComposable extends Composable = '$fetch', DefaultT extends LicencieGetBrevetByLicencieResponse = LicencieGetBrevetByLicencieResponse>(options: Options<TComposable, LicencieGetBrevetByLicencieData, LicencieGetBrevetByLicencieResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieGetBrevetByLicencieResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/brevets/{LicencieId}',
    ...options
});

/**
 * Brevets validés en tant que moniteur
 */
export const licencieGetBrevetByMoniteur = <TComposable extends Composable = '$fetch', DefaultT extends LicencieGetBrevetByMoniteurResponse = LicencieGetBrevetByMoniteurResponse>(options: Options<TComposable, LicencieGetBrevetByMoniteurData, LicencieGetBrevetByMoniteurResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieGetBrevetByMoniteurResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/moniteur/brevets/{MoniteurId}',
    ...options
});

/**
 * Suppression Licencie
 */
export const licencieSuppressionLicencie = <TComposable extends Composable = '$fetch', DefaultT extends LicencieSuppressionLicencieResponse = LicencieSuppressionLicencieResponse>(options: Options<TComposable, LicencieSuppressionLicencieData, LicencieSuppressionLicencieResponse, DefaultT>) => (options.client ?? client).delete<TComposable, LicencieSuppressionLicencieResponse | DefaultT, LicencieSuppressionLicencieError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/{licencieid}',
    ...options
});

/**
 * Url InfoLicencie
 */
export const licencieGetUrlInfoLicencie = <TComposable extends Composable = '$fetch', DefaultT extends LicencieGetUrlInfoLicencieResponse = LicencieGetUrlInfoLicencieResponse>(options: Options<TComposable, LicencieGetUrlInfoLicencieData, LicencieGetUrlInfoLicencieResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieGetUrlInfoLicencieResponse | DefaultT, LicencieGetUrlInfoLicencieError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/InfoLicencie/{licencieid}',
    ...options
});

/**
 * Récupérer Licencie par son Numéro de Licence
 */
export const licencieGetLicencieByNumeroLicence = <TComposable extends Composable = '$fetch', DefaultT extends LicencieGetLicencieByNumeroLicenceResponse = LicencieGetLicencieByNumeroLicenceResponse>(options: Options<TComposable, LicencieGetLicencieByNumeroLicenceData, LicencieGetLicencieByNumeroLicenceResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieGetLicencieByNumeroLicenceResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/NumeroLicence/{NumeroLicence}',
    ...options
});

/**
 * Url InfoLicencie
 */
export const licencieFusionLicencie = <TComposable extends Composable = '$fetch', DefaultT extends LicencieFusionLicencieResponse = LicencieFusionLicencieResponse>(options: Options<TComposable, LicencieFusionLicencieData, LicencieFusionLicencieResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieFusionLicencieResponse | DefaultT, LicencieFusionLicencieError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/Fusion',
    ...options
});

/**
 * Création Licencie
 */
export const licencieAnonymousCreate = <TComposable extends Composable = '$fetch', DefaultT extends LicencieAnonymousCreateResponse = LicencieAnonymousCreateResponse>(options: Options<TComposable, LicencieAnonymousCreateData, LicencieAnonymousCreateResponse, DefaultT>) => (options.client ?? client).post<TComposable, LicencieAnonymousCreateResponse | DefaultT, LicencieAnonymousCreateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/AnonymousCreate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Contrôle changement de catégorie d'âge
 */
export const licencieLicencieCategorieChange = <TComposable extends Composable = '$fetch', DefaultT extends LicencieLicencieCategorieChangeResponse = LicencieLicencieCategorieChangeResponse>(options: Options<TComposable, LicencieLicencieCategorieChangeData, LicencieLicencieCategorieChangeResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieLicencieCategorieChangeResponse | DefaultT, LicencieLicencieCategorieChangeError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/categorieChange/{LicencieId}',
    ...options
});

/**
 * Ajoute un panier licencié
 */
export const licencieCheckAndCreate = <TComposable extends Composable = '$fetch', DefaultT extends LicencieCheckAndCreateResponse = LicencieCheckAndCreateResponse>(options: Options<TComposable, LicencieCheckAndCreateData, LicencieCheckAndCreateResponse, DefaultT>) => (options.client ?? client).post<TComposable, LicencieCheckAndCreateResponse | DefaultT, LicencieCheckAndCreateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/CheckAndCreate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Permet de récupérer le prochain n° chrono non utilisé
 * Renvoie null si pas de n° libre
 */
export const licencieGetNextUnusedNumChrono = <TComposable extends Composable = '$fetch', DefaultT extends LicencieGetNextUnusedNumChronoResponse = LicencieGetNextUnusedNumChronoResponse>(options: Options<TComposable, LicencieGetNextUnusedNumChronoData, LicencieGetNextUnusedNumChronoResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieGetNextUnusedNumChronoResponse | DefaultT, LicencieGetNextUnusedNumChronoError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/GetNextUnusedNumChrono',
    ...options
});

/**
 * Récupère la liste des numéros chrono non utilisés
 * Renvoie une liste vide si pas de n° libre
 */
export const licencieGetAllUnusedNumsChrono = <TComposable extends Composable = '$fetch', DefaultT extends LicencieGetAllUnusedNumsChronoResponse = LicencieGetAllUnusedNumsChronoResponse>(options: Options<TComposable, LicencieGetAllUnusedNumsChronoData, LicencieGetAllUnusedNumsChronoResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieGetAllUnusedNumsChronoResponse | DefaultT, LicencieGetAllUnusedNumsChronoError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/GetAllUnusedNumsChrono',
    ...options
});

/**
 * Permet de récupérer le prochain n° chrono non utilisé
 * Renvoie null si pas de n° libre
 */
export const licencieGetDateMinBrevet = <TComposable extends Composable = '$fetch', DefaultT extends LicencieGetDateMinBrevetResponse = LicencieGetDateMinBrevetResponse>(options: Options<TComposable, LicencieGetDateMinBrevetData, LicencieGetDateMinBrevetResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieGetDateMinBrevetResponse | DefaultT, LicencieGetDateMinBrevetError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/dateMinBrevet/{licencieId}',
    ...options
});

/**
 * Extraction des brevets du licencié
 */
export const licencieGetBrevetsExtractionByLicencieId = <TComposable extends Composable = '$fetch', DefaultT extends LicencieGetBrevetsExtractionByLicencieIdResponse = LicencieGetBrevetsExtractionByLicencieIdResponse>(options: Options<TComposable, LicencieGetBrevetsExtractionByLicencieIdData, LicencieGetBrevetsExtractionByLicencieIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieGetBrevetsExtractionByLicencieIdResponse | DefaultT, LicencieGetBrevetsExtractionByLicencieIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/GetBrevetsExtractionByLicencieId',
    ...options
});

/**
 * Activation Licencie
 */
export const licencieActivateLicencee = <TComposable extends Composable = '$fetch', DefaultT extends LicencieActivateLicenceeResponse = LicencieActivateLicenceeResponse>(options: Options<TComposable, LicencieActivateLicenceeData, LicencieActivateLicenceeResponse, DefaultT>) => (options.client ?? client).post<TComposable, LicencieActivateLicenceeResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/ActivateLicencee',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Modification du numéro de licence
 */
export const licencieChangeLicenceNumber = <TComposable extends Composable = '$fetch', DefaultT = undefined>(options: Options<TComposable, LicencieChangeLicenceNumberData, unknown, DefaultT>) => (options.client ?? client).get<TComposable, unknown | DefaultT, LicencieChangeLicenceNumberError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/ChangeLicenceNumber',
    ...options
});

/**
 * Vérifie si l'email fournit est déjà utilisé
 */
export const licencieControlEmailUsage = <TComposable extends Composable = '$fetch', DefaultT extends LicencieControlEmailUsageResponse = LicencieControlEmailUsageResponse>(options: Options<TComposable, LicencieControlEmailUsageData, LicencieControlEmailUsageResponse, DefaultT>) => (options.client ?? client).post<TComposable, LicencieControlEmailUsageResponse | DefaultT, LicencieControlEmailUsageError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/ControlEmailUsage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retourne le nombre d'utilisateur possédant l'email fourni
 */
export const licencieCountEmailUsage = <TComposable extends Composable = '$fetch', DefaultT extends LicencieCountEmailUsageResponse = LicencieCountEmailUsageResponse>(options: Options<TComposable, LicencieCountEmailUsageData, LicencieCountEmailUsageResponse, DefaultT>) => (options.client ?? client).post<TComposable, LicencieCountEmailUsageResponse | DefaultT, LicencieCountEmailUsageError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/CountEmailUsage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retourne les licenciés utilisant l'email fourni en paramètre
 */
export const licencieListByEmail = <TComposable extends Composable = '$fetch', DefaultT extends LicencieListByEmailResponse = LicencieListByEmailResponse>(options: Options<TComposable, LicencieListByEmailData, LicencieListByEmailResponse, DefaultT>) => (options.client ?? client).post<TComposable, LicencieListByEmailResponse | DefaultT, LicencieListByEmailError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/ListByEmail',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Controle si la date et lieu de naissonce ont été modifié et si la commune saisie est valide le cas échéant
 */
export const licencieCheckBirthPlace = <TComposable extends Composable = '$fetch', DefaultT extends LicencieCheckBirthPlaceResponse = LicencieCheckBirthPlaceResponse>(options: Options<TComposable, LicencieCheckBirthPlaceData, LicencieCheckBirthPlaceResponse, DefaultT>) => (options.client ?? client).post<TComposable, LicencieCheckBirthPlaceResponse | DefaultT, LicencieCheckBirthPlaceError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/CheckBirthPlace',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * QRCode SVG
 */
export const licencieGetQrCode = <TComposable extends Composable = '$fetch', DefaultT extends LicencieGetQrCodeResponse = LicencieGetQrCodeResponse>(options: Options<TComposable, LicencieGetQrCodeData, LicencieGetQrCodeResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieGetQrCodeResponse | DefaultT, LicencieGetQrCodeError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/QRCode/{licencieid}',
    ...options
});

export const licencieGetCaci = <TComposable extends Composable = '$fetch', DefaultT extends LicencieGetCaciResponse = LicencieGetCaciResponse>(options: Options<TComposable, LicencieGetCaciData, LicencieGetCaciResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieGetCaciResponse | DefaultT, LicencieGetCaciError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Licencie/CACI/{licencieid}',
    ...options
});

/**
 * Listes TypeActivites
 */
export const typeActiviteGetAll = <TComposable extends Composable = '$fetch', DefaultT extends TypeActiviteGetAllResponse = TypeActiviteGetAllResponse>(options: Options<TComposable, TypeActiviteGetAllData, TypeActiviteGetAllResponse, DefaultT>) => (options.client ?? client).get<TComposable, TypeActiviteGetAllResponse | DefaultT, TypeActiviteGetAllError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/TypeActivite',
    ...options
});

/**
 * Création TypeActivite
 */
export const typeActiviteCreate = <TComposable extends Composable = '$fetch', DefaultT extends TypeActiviteCreateResponse = TypeActiviteCreateResponse>(options: Options<TComposable, TypeActiviteCreateData, TypeActiviteCreateResponse, DefaultT>) => (options.client ?? client).post<TComposable, TypeActiviteCreateResponse | DefaultT, TypeActiviteCreateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/TypeActivite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mise à jour TypeActivite
 */
export const typeActiviteUpdate = <TComposable extends Composable = '$fetch', DefaultT extends TypeActiviteUpdateResponse = TypeActiviteUpdateResponse>(options: Options<TComposable, TypeActiviteUpdateData, TypeActiviteUpdateResponse, DefaultT>) => (options.client ?? client).put<TComposable, TypeActiviteUpdateResponse | DefaultT, TypeActiviteUpdateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/TypeActivite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Listes TypeActivites
 */
export const typeActiviteGetAllWithPaging = <TComposable extends Composable = '$fetch', DefaultT extends TypeActiviteGetAllWithPagingResponse = TypeActiviteGetAllWithPagingResponse>(options: Options<TComposable, TypeActiviteGetAllWithPagingData, TypeActiviteGetAllWithPagingResponse, DefaultT>) => (options.client ?? client).post<TComposable, TypeActiviteGetAllWithPagingResponse | DefaultT, TypeActiviteGetAllWithPagingError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/TypeActivite/paging',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suppression TypeActivite
 */
export const typeActiviteDeleteById = <TComposable extends Composable = '$fetch', DefaultT extends TypeActiviteDeleteByIdResponse = TypeActiviteDeleteByIdResponse>(options: Options<TComposable, TypeActiviteDeleteByIdData, TypeActiviteDeleteByIdResponse, DefaultT>) => (options.client ?? client).delete<TComposable, TypeActiviteDeleteByIdResponse | DefaultT, TypeActiviteDeleteByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/TypeActivite/{Id}',
    ...options
});

/**
 * Récupérer TypeActivite via son Id
 */
export const typeActiviteTypeActiviteGetById = <TComposable extends Composable = '$fetch', DefaultT extends TypeActiviteTypeActiviteGetByIdResponse = TypeActiviteTypeActiviteGetByIdResponse>(options: Options<TComposable, TypeActiviteTypeActiviteGetByIdData, TypeActiviteTypeActiviteGetByIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, TypeActiviteTypeActiviteGetByIdResponse | DefaultT, TypeActiviteTypeActiviteGetByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/TypeActivite/{Id}',
    ...options
});

/**
 * Récupérer Utilisateur via son Id
 */
export const utilisateurUtilisateurGetById = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurUtilisateurGetByIdResponse = UtilisateurUtilisateurGetByIdResponse>(options: Options<TComposable, UtilisateurUtilisateurGetByIdData, UtilisateurUtilisateurGetByIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, UtilisateurUtilisateurGetByIdResponse | DefaultT, UtilisateurUtilisateurGetByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Utilisateur/{Id}',
    ...options
});

export const utilisateurCurrent = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurCurrentResponse = UtilisateurCurrentResponse>(options: Options<TComposable, UtilisateurCurrentData, UtilisateurCurrentResponse, DefaultT>) => (options.client ?? client).get<TComposable, UtilisateurCurrentResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Utilisateur/Me',
    ...options
});

/**
 * Retourne l'utilisateur courant au format utilisé par Mandarine E-learning
 */
export const utilisateurMandarineCurrent = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurMandarineCurrentResponse = UtilisateurMandarineCurrentResponse>(options: Options<TComposable, UtilisateurMandarineCurrentData, UtilisateurMandarineCurrentResponse, DefaultT>) => (options.client ?? client).get<TComposable, UtilisateurMandarineCurrentResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Utilisateur/MandarineMe',
    ...options
});

/**
 * Retourne l'utilisateur courant complété pour le carnet de plongée
 */
export const utilisateurCarnetCurrent = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurCarnetCurrentResponse = UtilisateurCarnetCurrentResponse>(options: Options<TComposable, UtilisateurCarnetCurrentData, UtilisateurCarnetCurrentResponse, DefaultT>) => (options.client ?? client).get<TComposable, UtilisateurCarnetCurrentResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Utilisateur/CarnetMe',
    ...options
});

/**
 * Chercher Utilisateurs
 */
export const utilisateurSearch = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurSearchResponse = UtilisateurSearchResponse>(options: Options<TComposable, UtilisateurSearchData, UtilisateurSearchResponse, DefaultT>) => (options.client ?? client).post<TComposable, UtilisateurSearchResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Utilisateur/Search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Chercher Utilisateurs
 */
export const utilisateurSearchCarnet = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurSearchCarnetResponse = UtilisateurSearchCarnetResponse>(options: Options<TComposable, UtilisateurSearchCarnetData, UtilisateurSearchCarnetResponse, DefaultT>) => (options.client ?? client).post<TComposable, UtilisateurSearchCarnetResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Utilisateur/SearchCarnet',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Permet de vérifier si l'utilisateur a été actif récemment
 * Met à jour DateDerniereConnexion à la date du jour si l'utilisateur est considéré comme actif
 * Par son identityUser id
 */
export const utilisateurCheckIsActive = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurCheckIsActiveResponse = UtilisateurCheckIsActiveResponse>(options: Options<TComposable, UtilisateurCheckIsActiveData, UtilisateurCheckIsActiveResponse, DefaultT>) => (options.client ?? client).get<TComposable, UtilisateurCheckIsActiveResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Utilisateur/CheckIsActive',
    ...options
});

/**
 * Permet de vérifier si l'utilisateur a été actif récemment
 * Met à jour DateDerniereConnexion à la date du jour si l'utilisateur est considéré comme actif
 * Par son identifiant
 */
export const utilisateurCheckIsActiveByIdentifiant = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurCheckIsActiveByIdentifiantResponse = UtilisateurCheckIsActiveByIdentifiantResponse>(options: Options<TComposable, UtilisateurCheckIsActiveByIdentifiantData, UtilisateurCheckIsActiveByIdentifiantResponse, DefaultT>) => (options.client ?? client).get<TComposable, UtilisateurCheckIsActiveByIdentifiantResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Utilisateur/CheckIsActiveByIdentifiant',
    ...options
});

export const utilisateurCheckIfExistByIdentifiant = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurCheckIfExistByIdentifiantResponse = UtilisateurCheckIfExistByIdentifiantResponse>(options: Options<TComposable, UtilisateurCheckIfExistByIdentifiantData, UtilisateurCheckIfExistByIdentifiantResponse, DefaultT>) => (options.client ?? client).get<TComposable, UtilisateurCheckIfExistByIdentifiantResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Utilisateur/CheckIfExistByIdentifiant',
    ...options
});

export const utilisateurGetMailForIdentifier = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurGetMailForIdentifierResponse = UtilisateurGetMailForIdentifierResponse>(options: Options<TComposable, UtilisateurGetMailForIdentifierData, UtilisateurGetMailForIdentifierResponse, DefaultT>) => (options.client ?? client).get<TComposable, UtilisateurGetMailForIdentifierResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Utilisateur/GetMailForIdentifier',
    ...options
});

export const utilisateurProcessClientConnection = <TComposable extends Composable = '$fetch', DefaultT = undefined>(options: Options<TComposable, UtilisateurProcessClientConnectionData, unknown, DefaultT>) => (options.client ?? client).get<TComposable, unknown | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Utilisateur/ProcessClientConnection',
    ...options
});

/**
 * Récupérer Licencie par son Numéro de Licence
 */
export const utilisateurGetUserByNumeroChrono = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurGetUserByNumeroChronoResponse = UtilisateurGetUserByNumeroChronoResponse>(options: Options<TComposable, UtilisateurGetUserByNumeroChronoData, UtilisateurGetUserByNumeroChronoResponse, DefaultT>) => (options.client ?? client).get<TComposable, UtilisateurGetUserByNumeroChronoResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/Utilisateur/NumChrono/{NumeroChrono}',
    ...options
});

/**
 * Listes UtilisateurExternes
 */
export const utilisateurExterneGetAll = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurExterneGetAllResponse = UtilisateurExterneGetAllResponse>(options: Options<TComposable, UtilisateurExterneGetAllData, UtilisateurExterneGetAllResponse, DefaultT>) => (options.client ?? client).get<TComposable, UtilisateurExterneGetAllResponse | DefaultT, UtilisateurExterneGetAllError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/UtilisateurExterne',
    ...options
});

/**
 * Création UtilisateurExterne
 */
export const utilisateurExterneCreate = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurExterneCreateResponse = UtilisateurExterneCreateResponse>(options: Options<TComposable, UtilisateurExterneCreateData, UtilisateurExterneCreateResponse, DefaultT>) => (options.client ?? client).post<TComposable, UtilisateurExterneCreateResponse | DefaultT, UtilisateurExterneCreateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/UtilisateurExterne',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mise à jour UtilisateurExterne
 */
export const utilisateurExterneUpdate = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurExterneUpdateResponse = UtilisateurExterneUpdateResponse>(options: Options<TComposable, UtilisateurExterneUpdateData, UtilisateurExterneUpdateResponse, DefaultT>) => (options.client ?? client).put<TComposable, UtilisateurExterneUpdateResponse | DefaultT, UtilisateurExterneUpdateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/UtilisateurExterne',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Listes UtilisateurExternes
 */
export const utilisateurExterneGetAllWithPaging = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurExterneGetAllWithPagingResponse = UtilisateurExterneGetAllWithPagingResponse>(options: Options<TComposable, UtilisateurExterneGetAllWithPagingData, UtilisateurExterneGetAllWithPagingResponse, DefaultT>) => (options.client ?? client).post<TComposable, UtilisateurExterneGetAllWithPagingResponse | DefaultT, UtilisateurExterneGetAllWithPagingError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/UtilisateurExterne/paging',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suppression UtilisateurExterne
 */
export const utilisateurExterneDeleteById = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurExterneDeleteByIdResponse = UtilisateurExterneDeleteByIdResponse>(options: Options<TComposable, UtilisateurExterneDeleteByIdData, UtilisateurExterneDeleteByIdResponse, DefaultT>) => (options.client ?? client).delete<TComposable, UtilisateurExterneDeleteByIdResponse | DefaultT, UtilisateurExterneDeleteByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/UtilisateurExterne/{Id}',
    ...options
});

/**
 * Récupérer UtilisateurExterne via son Id
 */
export const utilisateurExterneUtilisateurExterneGetById = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurExterneUtilisateurExterneGetByIdResponse = UtilisateurExterneUtilisateurExterneGetByIdResponse>(options: Options<TComposable, UtilisateurExterneUtilisateurExterneGetByIdData, UtilisateurExterneUtilisateurExterneGetByIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, UtilisateurExterneUtilisateurExterneGetByIdResponse | DefaultT, UtilisateurExterneUtilisateurExterneGetByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/UtilisateurExterne/{Id}',
    ...options
});

export const utilisateurExterneUploadPhotoOfficielle = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurExterneUploadPhotoOfficielleResponse = UtilisateurExterneUploadPhotoOfficielleResponse>(options: Options<TComposable, UtilisateurExterneUploadPhotoOfficielleData, UtilisateurExterneUploadPhotoOfficielleResponse, DefaultT>) => (options.client ?? client).post<TComposable, UtilisateurExterneUploadPhotoOfficielleResponse | DefaultT, UtilisateurExterneUploadPhotoOfficielleError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/UtilisateurExterne/{Id}/PhotoOfficielle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const utilisateurExterneUploadPhotoProfil = <TComposable extends Composable = '$fetch', DefaultT extends UtilisateurExterneUploadPhotoProfilResponse = UtilisateurExterneUploadPhotoProfilResponse>(options: Options<TComposable, UtilisateurExterneUploadPhotoProfilData, UtilisateurExterneUploadPhotoProfilResponse, DefaultT>) => (options.client ?? client).post<TComposable, UtilisateurExterneUploadPhotoProfilResponse | DefaultT, UtilisateurExterneUploadPhotoProfilError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Utilisateurs/UtilisateurExterne/{Id}/PhotoProfil',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Listes Structures
 */
export const structureGetAll = <TComposable extends Composable = '$fetch', DefaultT extends StructureGetAllResponse = StructureGetAllResponse>(options: Options<TComposable, StructureGetAllData, StructureGetAllResponse, DefaultT>) => (options.client ?? client).get<TComposable, StructureGetAllResponse | DefaultT, StructureGetAllError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Structure',
    ...options
});

export const structureUploadLogo = <TComposable extends Composable = '$fetch', DefaultT extends StructureUploadLogoResponse = StructureUploadLogoResponse>(options: Options<TComposable, StructureUploadLogoData, StructureUploadLogoResponse, DefaultT>) => (options.client ?? client).post<TComposable, StructureUploadLogoResponse | DefaultT, StructureUploadLogoError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Structure/{Id}/Logo',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verrouillage/Déverrouillage d'un structure
 */
export const structureVerrouillage = <TComposable extends Composable = '$fetch', DefaultT extends StructureVerrouillageResponse = StructureVerrouillageResponse>(options: Options<TComposable, StructureVerrouillageData, StructureVerrouillageResponse, DefaultT>) => (options.client ?? client).post<TComposable, StructureVerrouillageResponse | DefaultT, StructureVerrouillageError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Structure/{structureid}/Verrouillage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Récupérer Structure via son Id
 */
export const structureStructureGetById = <TComposable extends Composable = '$fetch', DefaultT extends StructureStructureGetByIdResponse = StructureStructureGetByIdResponse>(options: Options<TComposable, StructureStructureGetByIdData, StructureStructureGetByIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, StructureStructureGetByIdResponse | DefaultT, StructureStructureGetByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Structure/{Id}',
    ...options
});

/**
 * Récupérer les structures pour un comite regional
 */
export const structureGetStructuresByComiteRegionalId = <TComposable extends Composable = '$fetch', DefaultT extends StructureGetStructuresByComiteRegionalIdResponse = StructureGetStructuresByComiteRegionalIdResponse>(options: Options<TComposable, StructureGetStructuresByComiteRegionalIdData, StructureGetStructuresByComiteRegionalIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, StructureGetStructuresByComiteRegionalIdResponse | DefaultT, StructureGetStructuresByComiteRegionalIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Structure/ComiteRegional/{comiteid}',
    ...options
});

export const structureList = <TComposable extends Composable = '$fetch', DefaultT extends StructureListResponse = StructureListResponse>(options: Options<TComposable, StructureListData, StructureListResponse, DefaultT>) => (options.client ?? client).get<TComposable, StructureListResponse | DefaultT, StructureListError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Structure/List',
    ...options
});

/**
 * Chercher Structure par nom, code
 */
export const structureSearch = <TComposable extends Composable = '$fetch', DefaultT extends StructureSearchResponse = StructureSearchResponse>(options: Options<TComposable, StructureSearchData, StructureSearchResponse, DefaultT>) => (options.client ?? client).post<TComposable, StructureSearchResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Structure/Search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Chercher Structure par liste d'Id
 */
export const structureSearchListIds = <TComposable extends Composable = '$fetch', DefaultT extends StructureSearchListIdsResponse = StructureSearchListIdsResponse>(options: Options<TComposable, StructureSearchListIdsData, StructureSearchListIdsResponse, DefaultT>) => (options.client ?? client).post<TComposable, StructureSearchListIdsResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Structure/Search/Ids',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suppression ClubSca
 */
export const clubScaDeleteById = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaDeleteByIdResponse = ClubScaDeleteByIdResponse>(options: Options<TComposable, ClubScaDeleteByIdData, ClubScaDeleteByIdResponse, DefaultT>) => (options.client ?? client).delete<TComposable, ClubScaDeleteByIdResponse | DefaultT, ClubScaDeleteByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/{Id}',
    ...options
});

/**
 * Récupérer ClubSca via son Id
 */
export const clubScaClubScaGetById = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaClubScaGetByIdResponse = ClubScaClubScaGetByIdResponse>(options: Options<TComposable, ClubScaClubScaGetByIdData, ClubScaClubScaGetByIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, ClubScaClubScaGetByIdResponse | DefaultT, ClubScaClubScaGetByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/{Id}',
    ...options
});

/**
 * Listes ClubScas
 */
export const clubScaGetAll = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaGetAllResponse = ClubScaGetAllResponse>(options: Options<TComposable, ClubScaGetAllData, ClubScaGetAllResponse, DefaultT>) => (options.client ?? client).get<TComposable, ClubScaGetAllResponse | DefaultT, ClubScaGetAllError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca',
    ...options
});

/**
 * Création ClubSca
 */
export const clubScaCreate = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaCreateResponse = ClubScaCreateResponse>(options: Options<TComposable, ClubScaCreateData, ClubScaCreateResponse, DefaultT>) => (options.client ?? client).post<TComposable, ClubScaCreateResponse | DefaultT, ClubScaCreateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mise à jour ClubSca
 */
export const clubScaUpdate = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaUpdateResponse = ClubScaUpdateResponse>(options: Options<TComposable, ClubScaUpdateData, ClubScaUpdateResponse, DefaultT>) => (options.client ?? client).put<TComposable, ClubScaUpdateResponse | DefaultT, ClubScaUpdateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Récupérer les types d'adresses pour les Clubs / Scas
 */
export const clubScaGetTypeAdresses = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaGetTypeAdressesResponse = ClubScaGetTypeAdressesResponse>(options: Options<TComposable, ClubScaGetTypeAdressesData, ClubScaGetTypeAdressesResponse, DefaultT>) => (options.client ?? client).get<TComposable, ClubScaGetTypeAdressesResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/TypeAdresses',
    ...options
});

/**
 * Chercher ClubSca par nom, code
 */
export const clubScaSearch = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaSearchResponse = ClubScaSearchResponse>(options: Options<TComposable, ClubScaSearchData, ClubScaSearchResponse, DefaultT>) => (options.client ?? client).post<TComposable, ClubScaSearchResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/Search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Chercher ClubSca par liste d'Id
 */
export const clubScaSearchListIds = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaSearchListIdsResponse = ClubScaSearchListIdsResponse>(options: Options<TComposable, ClubScaSearchListIdsData, ClubScaSearchListIdsResponse, DefaultT>) => (options.client ?? client).post<TComposable, ClubScaSearchListIdsResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/Search/Ids',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Chercher ClubSca proche d'un point, rayon de recherche en Km
 */
export const clubScaSearchRayon = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaSearchRayonResponse = ClubScaSearchRayonResponse>(options: Options<TComposable, ClubScaSearchRayonData, ClubScaSearchRayonResponse, DefaultT>) => (options.client ?? client).post<TComposable, ClubScaSearchRayonResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/Search/Rayon',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Chercher ClubSca appartenants à une zone définie par un polygone
 * Les points du polygone doivent être définis dans l'ordre anti-horaire
 */
export const clubScaSearchPolygon = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaSearchPolygonResponse = ClubScaSearchPolygonResponse>(options: Options<TComposable, ClubScaSearchPolygonData, ClubScaSearchPolygonResponse, DefaultT>) => (options.client ?? client).post<TComposable, ClubScaSearchPolygonResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/Search/Polygon',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Chercher ClubSca dans une commune
 */
export const clubScaSearchCommune = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaSearchCommuneResponse = ClubScaSearchCommuneResponse>(options: Options<TComposable, ClubScaSearchCommuneData, ClubScaSearchCommuneResponse, DefaultT>) => (options.client ?? client).post<TComposable, ClubScaSearchCommuneResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/Search/Commune/{CommuneId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Chercher ClubSca dans un département
 */
export const clubScaSearchDepartement = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaSearchDepartementResponse = ClubScaSearchDepartementResponse>(options: Options<TComposable, ClubScaSearchDepartementData, ClubScaSearchDepartementResponse, DefaultT>) => (options.client ?? client).post<TComposable, ClubScaSearchDepartementResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/Search/Departement/{DepartementId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Chercher ClubSca dans une région
 */
export const clubScaSearchRegion = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaSearchRegionResponse = ClubScaSearchRegionResponse>(options: Options<TComposable, ClubScaSearchRegionData, ClubScaSearchRegionResponse, DefaultT>) => (options.client ?? client).post<TComposable, ClubScaSearchRegionResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/Search/Region/{RegionId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Chercher ClubSca dans une zone géographique
 */
export const clubScaSearchZoneGeographique = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaSearchZoneGeographiqueResponse = ClubScaSearchZoneGeographiqueResponse>(options: Options<TComposable, ClubScaSearchZoneGeographiqueData, ClubScaSearchZoneGeographiqueResponse, DefaultT>) => (options.client ?? client).post<TComposable, ClubScaSearchZoneGeographiqueResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/Search/ZoneGeographique/{ZoneGeographiqueId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const clubScaUploadLogo = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaUploadLogoResponse = ClubScaUploadLogoResponse>(options: Options<TComposable, ClubScaUploadLogoData, ClubScaUploadLogoResponse, DefaultT>) => (options.client ?? client).post<TComposable, ClubScaUploadLogoResponse | DefaultT, ClubScaUploadLogoError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/{Id}/Logo',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const clubScaPackLicences = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaPackLicencesResponse = ClubScaPackLicencesResponse>(options: Options<TComposable, ClubScaPackLicencesData, ClubScaPackLicencesResponse, DefaultT>) => (options.client ?? client).get<TComposable, ClubScaPackLicencesResponse | DefaultT, ClubScaPackLicencesError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/{Id}/PackLicences',
    ...options
});

/**
 * Récupérer ClubSca actifs d'un Comité Régional
 */
export const clubScaGetByComiteRegionalId = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaGetByComiteRegionalIdResponse = ClubScaGetByComiteRegionalIdResponse>(options: Options<TComposable, ClubScaGetByComiteRegionalIdData, ClubScaGetByComiteRegionalIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, ClubScaGetByComiteRegionalIdResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/ComiteRegional/{comiteid}',
    ...options
});

/**
 * Récupérer ClubSca actifs d'un Comité Départemental
 */
export const clubScaGetByComiteDepartementalId = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaGetByComiteDepartementalIdResponse = ClubScaGetByComiteDepartementalIdResponse>(options: Options<TComposable, ClubScaGetByComiteDepartementalIdData, ClubScaGetByComiteDepartementalIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, ClubScaGetByComiteDepartementalIdResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/ComiteDepartemental/{comiteid}',
    ...options
});

/**
 * Vérifie si le code donné existe déjà
 */
export const clubScaCodeExists = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaCodeExistsResponse = ClubScaCodeExistsResponse>(options: Options<TComposable, ClubScaCodeExistsData, ClubScaCodeExistsResponse, DefaultT>) => (options.client ?? client).get<TComposable, ClubScaCodeExistsResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/ClubSca/Exists/{code}',
    ...options
});

/**
 * Retourne une fiche club avec nom, adresse
 */
export const clubScaGetQuickView = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaGetQuickViewResponse = ClubScaGetQuickViewResponse>(options: Options<TComposable, ClubScaGetQuickViewData, ClubScaGetQuickViewResponse, DefaultT>) => (options.client ?? client).get<TComposable, ClubScaGetQuickViewResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/quickview/{code}',
    ...options
});

/**
 * Récupère ou génère le panier subaqua associé avec le club donné
 */
export const clubScaGetPanierSub = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaGetPanierSubResponse = ClubScaGetPanierSubResponse>(options: Options<TComposable, ClubScaGetPanierSubData, ClubScaGetPanierSubResponse, DefaultT>) => (options.client ?? client).get<TComposable, ClubScaGetPanierSubResponse | DefaultT, ClubScaGetPanierSubError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/{code}/panierSub',
    ...options
});

/**
 * Enregistre le panier subaqua avec l'adresse email renseignée
 */
export const clubScaSetPanierSubEmail = <TComposable extends Composable = '$fetch', DefaultT = undefined>(options: Options<TComposable, ClubScaSetPanierSubEmailData, unknown, DefaultT>) => (options.client ?? client).post<TComposable, unknown | DefaultT, ClubScaSetPanierSubEmailError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/{code}/panierSubMail',
    ...options
});

/**
 * Vérifie la disponibilité de l'adresse email pour subaqua
 */
export const clubScaCheckMailAvailability = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaCheckMailAvailabilityResponse = ClubScaCheckMailAvailabilityResponse>(options: Options<TComposable, ClubScaCheckMailAvailabilityData, ClubScaCheckMailAvailabilityResponse, DefaultT>) => (options.client ?? client).post<TComposable, ClubScaCheckMailAvailabilityResponse | DefaultT, ClubScaCheckMailAvailabilityError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Structures/Clubscas/ClubSca/checkMailAvailability',
    ...options
});

/**
 * Listes Adresses
 */
export const adresseGetAll = <TComposable extends Composable = '$fetch', DefaultT extends AdresseGetAllResponse = AdresseGetAllResponse>(options: Options<TComposable, AdresseGetAllData, AdresseGetAllResponse, DefaultT>) => (options.client ?? client).get<TComposable, AdresseGetAllResponse | DefaultT, AdresseGetAllError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/Adresse',
    ...options
});

/**
 * Création Adresse
 */
export const adresseCreate = <TComposable extends Composable = '$fetch', DefaultT extends AdresseCreateResponse = AdresseCreateResponse>(options: Options<TComposable, AdresseCreateData, AdresseCreateResponse, DefaultT>) => (options.client ?? client).post<TComposable, AdresseCreateResponse | DefaultT, AdresseCreateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/Adresse',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mise à jour Adresse
 */
export const adresseUpdate = <TComposable extends Composable = '$fetch', DefaultT extends AdresseUpdateResponse = AdresseUpdateResponse>(options: Options<TComposable, AdresseUpdateData, AdresseUpdateResponse, DefaultT>) => (options.client ?? client).put<TComposable, AdresseUpdateResponse | DefaultT, AdresseUpdateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/Adresse',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Listes Adresses
 */
export const adresseGetAllWithPaging = <TComposable extends Composable = '$fetch', DefaultT extends AdresseGetAllWithPagingResponse = AdresseGetAllWithPagingResponse>(options: Options<TComposable, AdresseGetAllWithPagingData, AdresseGetAllWithPagingResponse, DefaultT>) => (options.client ?? client).post<TComposable, AdresseGetAllWithPagingResponse | DefaultT, AdresseGetAllWithPagingError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/Adresse/paging',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suppression Adresse
 */
export const adresseDeleteById = <TComposable extends Composable = '$fetch', DefaultT extends AdresseDeleteByIdResponse = AdresseDeleteByIdResponse>(options: Options<TComposable, AdresseDeleteByIdData, AdresseDeleteByIdResponse, DefaultT>) => (options.client ?? client).delete<TComposable, AdresseDeleteByIdResponse | DefaultT, AdresseDeleteByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/Adresse/{Id}',
    ...options
});

/**
 * Récupérer Adresse via son Id
 */
export const adresseAdresseGetById = <TComposable extends Composable = '$fetch', DefaultT extends AdresseAdresseGetByIdResponse = AdresseAdresseGetByIdResponse>(options: Options<TComposable, AdresseAdresseGetByIdData, AdresseAdresseGetByIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, AdresseAdresseGetByIdResponse | DefaultT, AdresseAdresseGetByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/Adresse/{Id}',
    ...options
});

/**
 * Listes Adresses par structure
 */
export const adresseGetByStructure = <TComposable extends Composable = '$fetch', DefaultT extends AdresseGetByStructureResponse = AdresseGetByStructureResponse>(options: Options<TComposable, AdresseGetByStructureData, AdresseGetByStructureResponse, DefaultT>) => (options.client ?? client).get<TComposable, AdresseGetByStructureResponse | DefaultT, AdresseGetByStructureError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/Adresse/structure/{structureId}',
    ...options
});

/**
 * Adresse par structure et type
 */
export const adresseGetByStructureType = <TComposable extends Composable = '$fetch', DefaultT extends AdresseGetByStructureTypeResponse = AdresseGetByStructureTypeResponse>(options: Options<TComposable, AdresseGetByStructureTypeData, AdresseGetByStructureTypeResponse, DefaultT>) => (options.client ?? client).get<TComposable, AdresseGetByStructureTypeResponse | DefaultT, AdresseGetByStructureTypeError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/Adresse/structure/{structureId}/type/{typeAdresse}',
    ...options
});

/**
 * Listes CategorieSocioProfessionnelles
 */
export const categorieSocioProfessionnelleGetAll = <TComposable extends Composable = '$fetch', DefaultT extends CategorieSocioProfessionnelleGetAllResponse = CategorieSocioProfessionnelleGetAllResponse>(options: Options<TComposable, CategorieSocioProfessionnelleGetAllData, CategorieSocioProfessionnelleGetAllResponse, DefaultT>) => (options.client ?? client).get<TComposable, CategorieSocioProfessionnelleGetAllResponse | DefaultT, CategorieSocioProfessionnelleGetAllError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/CategorieSocioProfessionnelle',
    ...options
});

/**
 * Création CategorieSocioProfessionnelle
 */
export const categorieSocioProfessionnelleCreate = <TComposable extends Composable = '$fetch', DefaultT extends CategorieSocioProfessionnelleCreateResponse = CategorieSocioProfessionnelleCreateResponse>(options: Options<TComposable, CategorieSocioProfessionnelleCreateData, CategorieSocioProfessionnelleCreateResponse, DefaultT>) => (options.client ?? client).post<TComposable, CategorieSocioProfessionnelleCreateResponse | DefaultT, CategorieSocioProfessionnelleCreateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/CategorieSocioProfessionnelle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mise à jour CategorieSocioProfessionnelle
 */
export const categorieSocioProfessionnelleUpdate = <TComposable extends Composable = '$fetch', DefaultT extends CategorieSocioProfessionnelleUpdateResponse = CategorieSocioProfessionnelleUpdateResponse>(options: Options<TComposable, CategorieSocioProfessionnelleUpdateData, CategorieSocioProfessionnelleUpdateResponse, DefaultT>) => (options.client ?? client).put<TComposable, CategorieSocioProfessionnelleUpdateResponse | DefaultT, CategorieSocioProfessionnelleUpdateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/CategorieSocioProfessionnelle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Listes CategorieSocioProfessionnelles
 */
export const categorieSocioProfessionnelleGetAllWithPaging = <TComposable extends Composable = '$fetch', DefaultT extends CategorieSocioProfessionnelleGetAllWithPagingResponse = CategorieSocioProfessionnelleGetAllWithPagingResponse>(options: Options<TComposable, CategorieSocioProfessionnelleGetAllWithPagingData, CategorieSocioProfessionnelleGetAllWithPagingResponse, DefaultT>) => (options.client ?? client).post<TComposable, CategorieSocioProfessionnelleGetAllWithPagingResponse | DefaultT, CategorieSocioProfessionnelleGetAllWithPagingError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/CategorieSocioProfessionnelle/paging',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suppression CategorieSocioProfessionnelle
 */
export const categorieSocioProfessionnelleDeleteById = <TComposable extends Composable = '$fetch', DefaultT extends CategorieSocioProfessionnelleDeleteByIdResponse = CategorieSocioProfessionnelleDeleteByIdResponse>(options: Options<TComposable, CategorieSocioProfessionnelleDeleteByIdData, CategorieSocioProfessionnelleDeleteByIdResponse, DefaultT>) => (options.client ?? client).delete<TComposable, CategorieSocioProfessionnelleDeleteByIdResponse | DefaultT, CategorieSocioProfessionnelleDeleteByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/CategorieSocioProfessionnelle/{Id}',
    ...options
});

/**
 * Récupérer CategorieSocioProfessionnelle via son Id
 */
export const categorieSocioProfessionnelleCategorieSocioProfessionnelleGetById = <TComposable extends Composable = '$fetch', DefaultT extends CategorieSocioProfessionnelleCategorieSocioProfessionnelleGetByIdResponse = CategorieSocioProfessionnelleCategorieSocioProfessionnelleGetByIdResponse>(options: Options<TComposable, CategorieSocioProfessionnelleCategorieSocioProfessionnelleGetByIdData, CategorieSocioProfessionnelleCategorieSocioProfessionnelleGetByIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, CategorieSocioProfessionnelleCategorieSocioProfessionnelleGetByIdResponse | DefaultT, CategorieSocioProfessionnelleCategorieSocioProfessionnelleGetByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/CategorieSocioProfessionnelle/{Id}',
    ...options
});

/**
 * Listes Payss
 */
export const paysGetAll = <TComposable extends Composable = '$fetch', DefaultT extends PaysGetAllResponse = PaysGetAllResponse>(options: Options<TComposable, PaysGetAllData, PaysGetAllResponse, DefaultT>) => (options.client ?? client).get<TComposable, PaysGetAllResponse | DefaultT, PaysGetAllError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/Pays',
    ...options
});

export const paysAnonymousGetAll = <TComposable extends Composable = '$fetch', DefaultT extends PaysAnonymousGetAllResponse = PaysAnonymousGetAllResponse>(options: Options<TComposable, PaysAnonymousGetAllData, PaysAnonymousGetAllResponse, DefaultT>) => (options.client ?? client).get<TComposable, PaysAnonymousGetAllResponse | DefaultT, PaysAnonymousGetAllError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/Pays/AnonymousGetAll',
    ...options
});

/**
 * Listes Saisons
 */
export const saisonGetAll = <TComposable extends Composable = '$fetch', DefaultT extends SaisonGetAllResponse = SaisonGetAllResponse>(options: Options<TComposable, SaisonGetAllData, SaisonGetAllResponse, DefaultT>) => (options.client ?? client).get<TComposable, SaisonGetAllResponse | DefaultT, SaisonGetAllError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/Saison',
    ...options
});

/**
 * Création Saison
 */
export const saisonCreate = <TComposable extends Composable = '$fetch', DefaultT extends SaisonCreateResponse = SaisonCreateResponse>(options: Options<TComposable, SaisonCreateData, SaisonCreateResponse, DefaultT>) => (options.client ?? client).post<TComposable, SaisonCreateResponse | DefaultT, SaisonCreateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/Saison',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mise à jour Saison
 */
export const saisonUpdate = <TComposable extends Composable = '$fetch', DefaultT extends SaisonUpdateResponse = SaisonUpdateResponse>(options: Options<TComposable, SaisonUpdateData, SaisonUpdateResponse, DefaultT>) => (options.client ?? client).put<TComposable, SaisonUpdateResponse | DefaultT, SaisonUpdateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/Saison',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Listes Saisons
 */
export const saisonGetAllWithPaging = <TComposable extends Composable = '$fetch', DefaultT extends SaisonGetAllWithPagingResponse = SaisonGetAllWithPagingResponse>(options: Options<TComposable, SaisonGetAllWithPagingData, SaisonGetAllWithPagingResponse, DefaultT>) => (options.client ?? client).post<TComposable, SaisonGetAllWithPagingResponse | DefaultT, SaisonGetAllWithPagingError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/Saison/paging',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suppression Saison
 */
export const saisonDeleteById = <TComposable extends Composable = '$fetch', DefaultT extends SaisonDeleteByIdResponse = SaisonDeleteByIdResponse>(options: Options<TComposable, SaisonDeleteByIdData, SaisonDeleteByIdResponse, DefaultT>) => (options.client ?? client).delete<TComposable, SaisonDeleteByIdResponse | DefaultT, SaisonDeleteByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/Saison/{Id}',
    ...options
});

/**
 * Récupérer Saison via son Id
 */
export const saisonSaisonGetById = <TComposable extends Composable = '$fetch', DefaultT extends SaisonSaisonGetByIdResponse = SaisonSaisonGetByIdResponse>(options: Options<TComposable, SaisonSaisonGetByIdData, SaisonSaisonGetByIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, SaisonSaisonGetByIdResponse | DefaultT, SaisonSaisonGetByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/Saison/{Id}',
    ...options
});

/**
 * Listes Saisons jusqu'� la date du jour
 */
export const saisonGetUntilNow = <TComposable extends Composable = '$fetch', DefaultT extends SaisonGetUntilNowResponse = SaisonGetUntilNowResponse>(options: Options<TComposable, SaisonGetUntilNowData, SaisonGetUntilNowResponse, DefaultT>) => (options.client ?? client).get<TComposable, SaisonGetUntilNowResponse | DefaultT, SaisonGetUntilNowError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Referentiels/Saison/untilnow',
    ...options
});

/**
 * Suppression Licence
 */
export const licenceDeleteById = <TComposable extends Composable = '$fetch', DefaultT extends LicenceDeleteByIdResponse = LicenceDeleteByIdResponse>(options: Options<TComposable, LicenceDeleteByIdData, LicenceDeleteByIdResponse, DefaultT>) => (options.client ?? client).delete<TComposable, LicenceDeleteByIdResponse | DefaultT, LicenceDeleteByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Licences/Licence/LicencieId/{LicencieId}/SaisonId/{SaisonId}',
    ...options
});

/**
 * Récupérer Licence via son Id
 */
export const licenceLicenceGetById = <TComposable extends Composable = '$fetch', DefaultT extends LicenceLicenceGetByIdResponse = LicenceLicenceGetByIdResponse>(options: Options<TComposable, LicenceLicenceGetByIdData, LicenceLicenceGetByIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicenceLicenceGetByIdResponse | DefaultT, LicenceLicenceGetByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Licences/Licence/LicencieId/{LicencieId}/SaisonId/{SaisonId}',
    ...options
});

/**
 * Création Licence
 */
export const licenceCreate = <TComposable extends Composable = '$fetch', DefaultT extends LicenceCreateResponse = LicenceCreateResponse>(options: Options<TComposable, LicenceCreateData, LicenceCreateResponse, DefaultT>) => (options.client ?? client).post<TComposable, LicenceCreateResponse | DefaultT, LicenceCreateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Licences/Licence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mise à jour Licence
 */
export const licenceUpdate = <TComposable extends Composable = '$fetch', DefaultT extends LicenceUpdateResponse = LicenceUpdateResponse>(options: Options<TComposable, LicenceUpdateData, LicenceUpdateResponse, DefaultT>) => (options.client ?? client).put<TComposable, LicenceUpdateResponse | DefaultT, LicenceUpdateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Licences/Licence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Listes Licences par LicencieId
 */
export const licenceGetAllByLicencieId = <TComposable extends Composable = '$fetch', DefaultT extends LicenceGetAllByLicencieIdResponse = LicenceGetAllByLicencieIdResponse>(options: Options<TComposable, LicenceGetAllByLicencieIdData, LicenceGetAllByLicencieIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicenceGetAllByLicencieIdResponse | DefaultT, LicenceGetAllByLicencieIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Licences/Licence/LicencieId/{LicencieId}',
    ...options
});

/**
 * Vérifie si le licencié possède une licence en cours de validité
 */
export const licenceLicenceExiste = <TComposable extends Composable = '$fetch', DefaultT extends LicenceLicenceExisteResponse = LicenceLicenceExisteResponse>(options: Options<TComposable, LicenceLicenceExisteData, LicenceLicenceExisteResponse, DefaultT>) => (options.client ?? client).post<TComposable, LicenceLicenceExisteResponse | DefaultT, LicenceLicenceExisteError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Licences/Licence/CheckValidite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suppression d'une licence et génération d'un avoir
 */
export const licenceDeleteWithCredit = <TComposable extends Composable = '$fetch', DefaultT extends LicenceDeleteWithCreditResponse = LicenceDeleteWithCreditResponse>(options: Options<TComposable, LicenceDeleteWithCreditData, LicenceDeleteWithCreditResponse, DefaultT>) => (options.client ?? client).delete<TComposable, LicenceDeleteWithCreditResponse | DefaultT, LicenceDeleteWithCreditError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Licences/Licence/DeleteWithCredit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const licenceCardRenewal = <TComposable extends Composable = '$fetch', DefaultT extends LicenceCardRenewalResponse = LicenceCardRenewalResponse>(options: Options<TComposable, LicenceCardRenewalData, LicenceCardRenewalResponse, DefaultT>) => (options.client ?? client).post<TComposable, LicenceCardRenewalResponse | DefaultT, LicenceCardRenewalError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Licences/Licence/CardRenewal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const licenceCreatePastLicence = <TComposable extends Composable = '$fetch', DefaultT = undefined>(options: Options<TComposable, LicenceCreatePastLicenceData, unknown, DefaultT>) => (options.client ?? client).post<TComposable, unknown | DefaultT, LicenceCreatePastLicenceError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Licences/Licence/CreatePastLicence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const licenceImportGeneralGnpu = <TComposable extends Composable = '$fetch', DefaultT extends LicenceImportGeneralGnpuResponse = LicenceImportGeneralGnpuResponse>(options: Options<TComposable, LicenceImportGeneralGnpuData, LicenceImportGeneralGnpuResponse, DefaultT>) => (options.client ?? client).post<TComposable, LicenceImportGeneralGnpuResponse | DefaultT, LicenceImportGeneralGnpuError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Licences/Licence/ImportGeneralGNPU',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Listes Communes
 */
export const communeGetAll = <TComposable extends Composable = '$fetch', DefaultT extends CommuneGetAllResponse = CommuneGetAllResponse>(options: Options<TComposable, CommuneGetAllData, CommuneGetAllResponse, DefaultT>) => (options.client ?? client).get<TComposable, CommuneGetAllResponse | DefaultT, CommuneGetAllError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Geographies/Commune',
    ...options
});

/**
 * Listes Communes
 */
export const communeGetAllWithPaging = <TComposable extends Composable = '$fetch', DefaultT extends CommuneGetAllWithPagingResponse = CommuneGetAllWithPagingResponse>(options: Options<TComposable, CommuneGetAllWithPagingData, CommuneGetAllWithPagingResponse, DefaultT>) => (options.client ?? client).post<TComposable, CommuneGetAllWithPagingResponse | DefaultT, CommuneGetAllWithPagingError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Geographies/Commune/paging',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Récupérer Commune via son Id
 */
export const communeCommuneGetById = <TComposable extends Composable = '$fetch', DefaultT extends CommuneCommuneGetByIdResponse = CommuneCommuneGetByIdResponse>(options: Options<TComposable, CommuneCommuneGetByIdData, CommuneCommuneGetByIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, CommuneCommuneGetByIdResponse | DefaultT, CommuneCommuneGetByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Geographies/Commune/{Id}',
    ...options
});

/**
 * Récupérer la liste des communes d'une Région
 */
export const communeGetByRegion = <TComposable extends Composable = '$fetch', DefaultT extends CommuneGetByRegionResponse = CommuneGetByRegionResponse>(options: Options<TComposable, CommuneGetByRegionData, CommuneGetByRegionResponse, DefaultT>) => (options.client ?? client).get<TComposable, CommuneGetByRegionResponse | DefaultT, CommuneGetByRegionError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Geographies/Commune/Region/{RegionId}',
    ...options
});

/**
 * Récupérer la liste des communes d'un département
 */
export const communeGetByDepartement = <TComposable extends Composable = '$fetch', DefaultT extends CommuneGetByDepartementResponse = CommuneGetByDepartementResponse>(options: Options<TComposable, CommuneGetByDepartementData, CommuneGetByDepartementResponse, DefaultT>) => (options.client ?? client).get<TComposable, CommuneGetByDepartementResponse | DefaultT, CommuneGetByDepartementError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Geographies/Commune/Departement/{DepartementId}',
    ...options
});

/**
 * Récupérer la liste des communes adjacentes à une commune
 */
export const communeGetCommunesAdjacentes = <TComposable extends Composable = '$fetch', DefaultT extends CommuneGetCommunesAdjacentesResponse = CommuneGetCommunesAdjacentesResponse>(options: Options<TComposable, CommuneGetCommunesAdjacentesData, CommuneGetCommunesAdjacentesResponse, DefaultT>) => (options.client ?? client).get<TComposable, CommuneGetCommunesAdjacentesResponse | DefaultT, CommuneGetCommunesAdjacentesError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Geographies/Commune/{id}/CommunesAdjacentes',
    ...options
});

/**
 * Récupérer la liste des communes par code postal
 */
export const communeGetCommunesByPostalCode = <TComposable extends Composable = '$fetch', DefaultT extends CommuneGetCommunesByPostalCodeResponse = CommuneGetCommunesByPostalCodeResponse>(options: Options<TComposable, CommuneGetCommunesByPostalCodeData, CommuneGetCommunesByPostalCodeResponse, DefaultT>) => (options.client ?? client).get<TComposable, CommuneGetCommunesByPostalCodeResponse | DefaultT, CommuneGetCommunesByPostalCodeError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Geographies/Commune/CodePostal/{cp}',
    ...options
});

/**
 * Récupérer la liste des communes par nom
 */
export const communeGetCommuneByName = <TComposable extends Composable = '$fetch', DefaultT extends CommuneGetCommuneByNameResponse = CommuneGetCommuneByNameResponse>(options: Options<TComposable, CommuneGetCommuneByNameData, CommuneGetCommuneByNameResponse, DefaultT>) => (options.client ?? client).get<TComposable, CommuneGetCommuneByNameResponse | DefaultT, CommuneGetCommuneByNameError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Geographies/Commune/SearchName/{name}',
    ...options
});

/**
 * Chercher ClubSca par nom, code
 */
export const clubScaSearch2 = <TComposable extends Composable = '$fetch', DefaultT extends ClubScaSearch2Response = ClubScaSearch2Response>(options: Options<TComposable, ClubScaSearch2Data, ClubScaSearch2Response, DefaultT>) => (options.client ?? client).get<TComposable, ClubScaSearch2Response | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Externe/ClubSca/Search',
    ...options
});

/**
 * Lister les moniteurs d'un Club/Sca
 */
export const licencieSearchByClubSca2 = <TComposable extends Composable = '$fetch', DefaultT extends LicencieSearchByClubSca2Response = LicencieSearchByClubSca2Response>(options: Options<TComposable, LicencieSearchByClubSca2Data, LicencieSearchByClubSca2Response, DefaultT>) => (options.client ?? client).get<TComposable, LicencieSearchByClubSca2Response | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Externe/Licencie/MoniteursClubSca',
    ...options
});

/**
 * Chercher un moniteur par nom, num licence
 */
export const licencieSearchMoniteurs = <TComposable extends Composable = '$fetch', DefaultT extends LicencieSearchMoniteursResponse = LicencieSearchMoniteursResponse>(options: Options<TComposable, LicencieSearchMoniteursData, LicencieSearchMoniteursResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieSearchMoniteursResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Externe/Licencie/SearchMoniteurs',
    ...options
});

/**
 * Chercher un licencie par nom, num licence
 */
export const licencieSearchLicencies = <TComposable extends Composable = '$fetch', DefaultT extends LicencieSearchLicenciesResponse = LicencieSearchLicenciesResponse>(options: Options<TComposable, LicencieSearchLicenciesData, LicencieSearchLicenciesResponse, DefaultT>) => (options.client ?? client).get<TComposable, LicencieSearchLicenciesResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Externe/Licencie/SearchLicencies',
    ...options
});

/**
 * Listes BrevetExternes
 */
export const brevetExterneGetAll = <TComposable extends Composable = '$fetch', DefaultT extends BrevetExterneGetAllResponse = BrevetExterneGetAllResponse>(options: Options<TComposable, BrevetExterneGetAllData, BrevetExterneGetAllResponse, DefaultT>) => (options.client ?? client).get<TComposable, BrevetExterneGetAllResponse | DefaultT, BrevetExterneGetAllError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Brevets/BrevetExterne',
    ...options
});

/**
 * Création BrevetExterne
 */
export const brevetExterneCreate = <TComposable extends Composable = '$fetch', DefaultT extends BrevetExterneCreateResponse = BrevetExterneCreateResponse>(options: Options<TComposable, BrevetExterneCreateData, BrevetExterneCreateResponse, DefaultT>) => (options.client ?? client).post<TComposable, BrevetExterneCreateResponse | DefaultT, BrevetExterneCreateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Brevets/BrevetExterne',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mise à jour BrevetExterne
 */
export const brevetExterneUpdate = <TComposable extends Composable = '$fetch', DefaultT extends BrevetExterneUpdateResponse = BrevetExterneUpdateResponse>(options: Options<TComposable, BrevetExterneUpdateData, BrevetExterneUpdateResponse, DefaultT>) => (options.client ?? client).put<TComposable, BrevetExterneUpdateResponse | DefaultT, BrevetExterneUpdateError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Brevets/BrevetExterne',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Listes BrevetExternes
 */
export const brevetExterneGetAllWithPaging = <TComposable extends Composable = '$fetch', DefaultT extends BrevetExterneGetAllWithPagingResponse = BrevetExterneGetAllWithPagingResponse>(options: Options<TComposable, BrevetExterneGetAllWithPagingData, BrevetExterneGetAllWithPagingResponse, DefaultT>) => (options.client ?? client).post<TComposable, BrevetExterneGetAllWithPagingResponse | DefaultT, BrevetExterneGetAllWithPagingError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Brevets/BrevetExterne/paging',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suppression BrevetExterne
 */
export const brevetExterneDeleteById = <TComposable extends Composable = '$fetch', DefaultT extends BrevetExterneDeleteByIdResponse = BrevetExterneDeleteByIdResponse>(options: Options<TComposable, BrevetExterneDeleteByIdData, BrevetExterneDeleteByIdResponse, DefaultT>) => (options.client ?? client).delete<TComposable, BrevetExterneDeleteByIdResponse | DefaultT, BrevetExterneDeleteByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Brevets/BrevetExterne/{Id}',
    ...options
});

/**
 * Récupérer BrevetExterne via son Id
 */
export const brevetExterneBrevetExterneGetById = <TComposable extends Composable = '$fetch', DefaultT extends BrevetExterneBrevetExterneGetByIdResponse = BrevetExterneBrevetExterneGetByIdResponse>(options: Options<TComposable, BrevetExterneBrevetExterneGetByIdData, BrevetExterneBrevetExterneGetByIdResponse, DefaultT>) => (options.client ?? client).get<TComposable, BrevetExterneBrevetExterneGetByIdResponse | DefaultT, BrevetExterneBrevetExterneGetByIdError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Brevets/BrevetExterne/{Id}',
    ...options
});

/**
 * Listes BrevetExternes par licencie
 */
export const brevetExterneGetByLicencie = <TComposable extends Composable = '$fetch', DefaultT extends BrevetExterneGetByLicencieResponse = BrevetExterneGetByLicencieResponse>(options: Options<TComposable, BrevetExterneGetByLicencieData, BrevetExterneGetByLicencieResponse, DefaultT>) => (options.client ?? client).get<TComposable, BrevetExterneGetByLicencieResponse | DefaultT, BrevetExterneGetByLicencieError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Brevets/BrevetExterne/licencie/{licencieId}',
    ...options
});

/**
 * Listes BrevetExternes par licencie
 */
export const brevetExterneSaveForLicencie = <TComposable extends Composable = '$fetch', DefaultT = undefined>(options: Options<TComposable, BrevetExterneSaveForLicencieData, unknown, DefaultT>) => (options.client ?? client).post<TComposable, unknown | DefaultT, BrevetExterneSaveForLicencieError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/V1/Brevets/BrevetExterne/licencie/{licencieId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
